import React, { FC } from 'react';
import { HiOutlineCalendar } from 'react-icons/hi';

interface DateInputProps {
  label?: string;
  name: string;
  value?: string;
  onChange?: (value: string) => void;
  setFieldValue?: (field: string, value: any) => void;
  error?: string;
  touched?: boolean;
  placeholder?: string;
  className?: string;
  minDate?: Date | string;
  disabled?: boolean;
  [x: string]: any;
}

const DateInput: FC<DateInputProps> = ({
  label,
  name,
  value,
  onChange,
  setFieldValue,
  error,
  touched,
  placeholder,
  className,
  minDate,
  disabled,
  ...props
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    
    if (setFieldValue) {
      setFieldValue(name, newValue);
    }
    if (onChange) {
       onChange(newValue);
    }
  };

  // Ensure minDate is in YYYY-MM-DD format for native input
  const getMinDateString = () => {
    if (!minDate) return undefined;
    if (typeof minDate === 'string') return minDate.split('T')[0];
    try {
      return minDate.toISOString().split('T')[0];
    } catch {
      return undefined;
    }
  };

  return (
    <div className={`w-full ${className || ''}`}>
        {label && (
            <label htmlFor={name} className='block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1.5'>
            {label}
            </label>
        )}
        <div className='relative group'>
            <input
                type='date'
                id={name}
                name={name}
                value={value || ''}
                onChange={handleChange}
                min={getMinDateString()}
                disabled={disabled}
                placeholder={placeholder}
                className={`
                    w-full pl-11 pr-4 py-3
                    bg-gray-50 dark:bg-gray-800 
                    border border-gray-200 dark:border-gray-700 
                    rounded-xl 
                    text-gray-900 dark:text-white
                    placeholder:text-gray-400
                    text-base
                    transition-all duration-200
                    focus:outline-none focus:ring-4 focus:ring-primary-500/10 focus:border-primary-500
                    hover:border-gray-300 dark:hover:border-gray-600
                    disabled:bg-gray-100 dark:disabled:bg-gray-900/50 disabled:cursor-not-allowed
                    cursor-pointer
                    [color-scheme:light] dark:[color-scheme:dark]
                    ${error && touched ? 'border-red-500 focus:border-red-500 focus:ring-red-500/10' : ''}
                `}
                {...props}
            />
            <div className='absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none z-10 group-focus-within:text-primary-500 transition-colors'>
                <HiOutlineCalendar className='w-5 h-5' />
            </div>
        </div>
        {touched && error && (
            <div className='text-red-500 text-sm mt-1 animate-in slide-in-from-top-1 font-medium'>{error}</div>
        )}
    </div>
  );
};

export default DateInput;
